export const getTopFlopOperators = (operators) => {
  const filtered_operators = operators.filter(
    (operator) => operator?.average_grade && operator?.average_grade > 0
  );
  const sorted_operators = filtered_operators.sort(
    (a, b) => Number(b.average_grade) - Number(a.average_grade)
  );
  const top_operators = sorted_operators.slice(0, 2);
  const flop_operators = sorted_operators.slice(sorted_operators.length - 2);
  if (sorted_operators?.length <= 4) {
    return sorted_operators;
  }
  return [...top_operators, ...flop_operators];
};
